export enum addOrUpdateMSAccountType {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
}
